import Section from "../../../../components/section";
import { ReactComponent as ArrowBackIcon } from '../../../../assets/icons/arrow-back.svg';
import { useNavigate, useParams } from "react-router-dom";
import './edit-mid-page.scss';
import EditMidPartForm from "./edit-mid.part.form";

const EditMidPage = () => {
    const navigate = useNavigate();

    const { id } = useParams();

    return (
        <div className="edit-mid-page page-content">
            <div className="page-header flex-row flex-gap-20 flex-align-start-center">
                <ArrowBackIcon
                    className="back-icon pointer"
                    onClick={() => navigate(-1)}
                />
                <div className='page-title'>
                    Edit MID
                </div>
            </div>
            <Section>
                {id &&
                    <EditMidPartForm id={id}/>
                }
            </Section>
        </div>
    )
}

export default EditMidPage;